export default __webpack_public_path__ + "static/media/bg.b69c1bda.jpg";